import React from "react";

import AddShop from "commonComponents/addShop/AddShop";
import logo from "assets/img/sparkLoginLogo.svg";
import "./standalonePage.css";

/**
 * ShopAddShop - the standalone "tell us about your shop" page.
 *
 * Step two of signing up, reached straight after the account exists,
 * so it renders outside the panel and supplies its own frame. AddShop
 * renders bare here and the panels inside it carry the structure — the
 * old wrapper put the whole form inside one more white card.
 */
const ShopAddShop = () => (
  <div className="standalonePage">
    <div className="standaloneInner isWide">
      <div className="standaloneBrand">
        <img src={logo} alt="Spark" />
      </div>

      <div className="standaloneHead">
        <h1 className="standaloneTitle">Tell us about your shop</h1>
        <p className="standaloneSubtitle">
          Step 2 of 4 — we review these details before your shop goes live.
        </p>
      </div>

      <AddShop type="shopAdmin" />
    </div>
  </div>
);

export default ShopAddShop;
